<template>
  <d-card class="card-small mb-3">
    <d-card-body>
      <d-form class="add-new-post" @submit.native.prevent="submit">
        <strong class="text-muted d-block mb-2">Name</strong>
        <textarea v-model="form.name" class="tier-name-editor" />
        <d-form-invalid-feedback :force-show="!form.name && showError"
          >Tier name cannot be empty!</d-form-invalid-feedback
        >
        <div
          class="row"
          style="margin-right: -0px;
    margin-left: 0px;"
        >
          <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0 pr-0 pl-0">
            <strong class="text-muted d-block mb-2">Subtitle</strong>
            <textarea v-model="form.subtitle" class="tier-name-editor" />
            <d-form-invalid-feedback :force-show="!form.subtitle && showError"
              >Subtitle field cannot be empty!</d-form-invalid-feedback
            >
          </d-col>
          <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0 pr-0">
            <strong class="text-muted d-block mb-2">Emoji</strong>
            <textarea-emoji-picker
              v-model="form.emoji"
              class="tier-name-editor"
            />
            <d-form-invalid-feedback :force-show="!form.emoji && showError"
              >Emoji field cannot be empty!</d-form-invalid-feedback
            >
          </d-col>
          <d-col
            col
            sm="6"
            class="text-center text-sm-left mb-4 mb-sm-0 pl-0 pr-0"
          >
            <strong class="text-muted d-block mb-2">Level</strong>
            <d-input-group prepend="Select" class="mb-3">
              <d-select v-model="form.level" name="level">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </d-select>
            </d-input-group>
          </d-col>
          <!--<d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0 pr-0">
            <strong class="text-muted d-block mb-2">Actions Required</strong>
            <d-input-group prepend="Amount" class="mb-3">
              <d-select v-model="form.required_actions" name="required_actions">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </d-select>
            </d-input-group>
          </d-col>-->
        <!--  <d-col
            col
            sm="6"
            class="text-center text-sm-left mb-4 mb-sm-0 pr-0"
            style="padding-left:0px;"
          >
            <strong class="text-muted d-block mb-2"
              >Show Number of supporters</strong
            >
            <d-button-group class="mb-3">
              <d-button
                type="button"
                @click.native="form.show_no_of_supporters = true"
                v-bind:class="
                  form.show_no_of_supporters ? 'btn-primary' : 'btn-white'
                "
                >Yes</d-button
              >
              <d-button
                @click.native="form.show_no_of_supporters = false"
                type="button"
                v-bind:class="
                  form.show_no_of_supporters ? 'btn-white' : 'btn-primary'
                "
                >No</d-button
              >
            </d-button-group>
          </d-col>
          <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0 pr-0">
            <strong class="text-muted d-block mb-2"
              >Manual Number of supporters</strong
            >
            <d-input-group class="mb-3">
              <d-input
                name="no_of_supporters"
                placeholder="Leave blank to show actual"
                v-model="form.no_of_supporters"
              />
            </d-input-group>
          </d-col>-->
        </div>
        <strong class="text-muted d-block mb-2">Description</strong>
        <textarea
          class="form-control"
          v-model="form.details_and_benefits"
          placeholder="Describe what happens when a supporter joins this tier. Do they receive benefits? Do they make an impact? Maybe a special thank you?"
          rows="6"
          max-rows="8"
          name="details_and_benefits"
          :style="{ fontSize: '1rem' }"
        />
        <d-form-invalid-feedback
          :force-show="!form.details_and_benefits && showError"
          >Please write something</d-form-invalid-feedback
        >
        <!-- Toggle Buttons -->
        <strong class="text-muted d-block mb-2 mt-2">Visibility</strong>
        <d-button-group class="mb-3">
          <d-button
            type="button"
            @click.native="form.visibility = true"
            v-bind:class="
              form.visibility === true ? 'btn-primary' : 'btn-white'
            "
            >Live</d-button
          >
          <d-button
            type="button"
            @click.native="form.visibility = false"
            v-bind:class="
              form.visibility === false ? 'btn-primary' : 'btn-white'
            "
            >Draft</d-button
          >
        </d-button-group>

        <div
          class="row"
          style="margin-right: -0px;
    margin-left: 0px;"
        >
          <d-col
            col
            sm="6"
            class="text-center text-sm-left mb-4 mb-sm-0 pl-0 pr-0"
          >
            <d-button
              v-if="addButton && !addTierLoading && !updateTierLoading"
              size="sm"
              class="btn-accent ml-auto mt-2"
              type="submit"
            >
              <i class="material-icons">add </i> Add
            </d-button>
            <d-button
              v-if="!addButton && !addTierLoading && !updateTierLoading"
              size="sm"
              class="btn-accent ml-auto mt-2"
              type="submit"
            >
              <i class="material-icons">save</i> Save
            </d-button>
            <d-button
              @click.native="cancel"
              v-if="!addButton && !addTierLoading && !updateTierLoading"
              size="sm"
              class="btn-accent  cancel-btn ml-auto mt-2"
              type="button"
            >
              <i class="material-icons">cancel</i> Cancel
            </d-button>
            <d-button
              v-if="addTierLoading || updateTierLoading"
              size="sm"
              class="btn-accent loading-btn ml-auto mt-2"
              type="button"
            >
              <img
                class="loading-img"
                src="./../../assets/images/Spinner-1s-200px.svg"
                alt="Loader"
              />
            </d-button>
          </d-col>
        </div>
      </d-form>
    </d-card-body>
    <modal
      :showModal="showModal"
      :message="modalMessage"
      :title="modalTitle"
      @modalClose="closeModal"
    ></modal>
  </d-card>
</template>

<script>
import Quill from "quill";
import TextareaEmojiPicker from "./TextareaEmojiPicker";
import Modal from "../Modal";
import { mapState, mapGetters } from "vuex";

export default {
  name: "tier-editor",
  data() {
    return {
      text: "",
      showError: false,
      tier: {},
      form: {
        name: "",
        emoji: "",
        visibility: true,
        level: 1,
        required_actions: 1,
        show_no_of_supporters: true,
        no_of_supporters: 0,
        details_and_benefits: "",
        actions: [],
        subtitle: ""
      },
      showModal: false,
      modalMessage: "",
      modalTitle: "",
      validations: {
        actions: false
      }
    };
  },
  props: {
    selectedTier: {
      type: Object,
      default: function() {
        return {};
      }
    },
    selectedActions: { type: Array, default: () => [] },
    addButton: { type: Boolean, default: true }
  },
  computed: {
    ...mapState({ actions: state => state.actions.data.actions || [] }),
    ...mapGetters(["addTierLoading", "fetchTiersLoading", "updateTierLoading"])
  },
  components: { TextareaEmojiPicker, Modal },
  watch: {
    selectedTier(newTier) {
      this.tier = newTier;
    },
    selectedActions(newSelectedAction) {
      this.form.actions = this.actions
        .filter(action => newSelectedAction.includes(action.button_text))
        .map(action => action._id);
      this.form.actions = this.actions.filter(action =>
        newSelectedAction.includes(action.button_text)
      );
    },
    tier(newTier) {
      this.form = {
        name: newTier.name || "",
        subtitle: newTier.subtitle || "",
        emoji: newTier.emoji || "",
        visibility: newTier.visibility || true,
        level: newTier.level || 1,
        required_actions: newTier.required_actions || 1,
        show_no_of_supporters: newTier.show_no_of_supporters || true,
        no_of_supporters: newTier.no_of_supporters || 0,
        details_and_benefits: newTier.details_and_benefits || "",
        actions: newTier.actions || []
      };
      if (!this.addButton && Object.keys(newTier).length > 0) {
        this.form._id = newTier._id;
      }
    }
  },
  methods: {
    addButtonClicked(addButton) {
      this.$emit("addButtonClick", addButton);
    },
    formIsValid() {
      this.showError = false;
      /*if (this.form.actions.length < 1) {
        this.validations.actions = true;
      }*/
      if (this.addButton) {
        if (
          !this.form.name ||
          !this.form.details_and_benefits ||
          !this.form.emoji ||
          !this.form.subtitle /*||
          this.form.actions.length < 1*/
        ) {
          this.showError = true;
          return false;
        }
      } else {
        if (
          !this.form.name ||
          !this.form.details_and_benefits ||
          !this.form.emoji ||
          !this.form.subtitle /*||
          this.form.actions.length < 1*/
        ) {
          this.showError = true;
          return false;
        }
      }
      return true;
    },
    submit() {
      if (this.formIsValid()) {
        if (!this.addButton) {
          this.tier = { actions: [] };
          this.addButtonClicked(true);
          this.$store.dispatch("updateTier", this.form);
          return;
        }
        this.$store.dispatch("addTier", this.form);
        return;
      }
      if (this.validations.actions) {
        this.showModal = true;
        this.modalMessage = "Atleast one actions must be assigned to tier";
        this.modalTitle = "Validation error";
        this.validations.actions = false;
      }
    },
    cancel() {
      this.tier = { actions: [] };
      this.addButtonClicked(true);
    },
    closeModal(close) {
      this.showModal = close;
    }
  }
};
</script>
<style scoped lang="scss">
.add-new-post__editor {
  min-height: 150px !important;
}

.emoji-picker {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-weight: 300;
  line-height: 1.5;
  color: #abb6bf;
  background-color: white;
  border: 1px solid #e1e5eb;
  border-radius: 0.25rem;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  cursor: pointer;
}
.emoji-picker:hover {
  border: 1px solid #f2557a;
  box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1),
    0 0.156rem 0.125rem rgba(0, 0, 0, 0.06);
}
.picker-overlay {
  width: 353px;
  position: absolute;
  z-index: 1000000;
  -webkit-box-shadow: 10px 10px 37px -10px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 10px 10px 37px -10px rgba(0, 0, 0, 0.4);
  box-shadow: 10px 10px 37px -10px rgba(0, 0, 0, 0.4);
}

.half {
  width: 40%;
}
.cancel-btn {
  margin-left: 10px !important;
}
.loading-btn {
  position: relative;
  padding: 15px;
  width: 4rem;

  .loading-img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 30px;
  }
}
.tier-name-editor {
  height: 50px;
  width: 100%;
  margin-bottom: 15px;
  padding: 0.4375rem 0.75rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #e1e5eb;
  font-weight: 300;
  will-change: border-color, box-shadow;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: box-shadow 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06),
    border 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);
}
.tier-name-editor:hover {
  border-color: #b3bdcc;
}
.tier-name-editor:focus {
  color: #495057;
  background-color: #fff;
  border-color: #f2557a;
  box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1),
    0 0.156rem 0.125rem rgba(0, 0, 0, 0.06);
}
</style>
